import React from "react";
import { Helmet } from "react-helmet";
import { graphql } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import styles from "./styles";
import { Script } from "gatsby";
const useStyles = makeStyles((theme) => styles(theme));

export const AcfAirshipEmbedBlock = (props) => {
  const classes = useStyles();

  return (
    <div className={`airship-embed ${classes.airshipEmbed}`}>
      <iframe
        src={props.block.blockAirshipEmbed.formUrl}
        width="100%"
        height={props.block.blockAirshipEmbed.frameHeight}
      />
      {/* <div data-airship-form-url={props.block.blockAirshipEmbed.formUrl}></div> */}
      {/* <Helmet>
        <Script src="https://pages.airship.co.uk/assets/js/embed.js" strategy="post-hydrate" />
      </Helmet> */}
    </div>
  );
};

export const AcfAirshipEmbedBlockFragment = graphql`
  fragment AcfAirshipEmbedBlock on WpBlock {
    ... on WpAcfAirshipEmbedBlock {
      name
      blockAirshipEmbed {
        formUrl
        frameHeight
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const AcfAirshipEmbedBlockPreview = `
    ... on AcfAirshipEmbedBlock {
        name
        blockAirshipEmbed {
          formUrl
          frameHeight
        }
    }
`;
